import './MainPageSub03_1.scss';
// import img1 from '../images/home/fig_where.png'; 
// import img1 from '../images/home/logo_trans2.png'; 
// import img1 from '../images/home/logo_bg.png'; 
// import img1 from '../images/home/logo_bg3.png'; 
// import img2 from '../images/home/logo_text.png'; 

import MainPageSub03_1logo from './MainPageSub03_1logo';
import React, { useEffect } from 'react';
import 'aos/dist/aos.css';
import AOS from 'aos';

const MainPageSub03_1 = () => {

    useEffect(() => {
        AOS.init({
            duration: 1500,
            easing: 'ease-in-out',
        });
    
    }, []);

    // const text = "학업역량  종합진단평가  코칭프로그램 ";

    // const colors = ["#B0B0B0", "#007B7B", "#D9771C", "#C3423F"];




    //=====================================================================
    return (
        <div className="MainPageSub03_1">
            <section className='sec-main'>

                <p className="heading-1 title1">
                    03 <span className="i-custom">목표</span>를 품다
                </p>

                <section className='sec-sub1'>

<article className='art-main'>

    <p className="heading-3 title2" data-aos="fade-down" data-aos-duration="1000">
        나의 꿈, 방향과 속도로 증명하다!
    </p>

    <section className="description" data-aos="zoom-in" data-aos-delay="300">
        <p>
            <mark>공부력</mark>은 이유있는 방향과 속도에 의해서만 만들어집니다. <br />
            바로 이때의 <mark>훈련은 진로확정에 의한 동기부여로 충족</mark>됩니다.<br />
            <mark>이유없는 공부력</mark>은 좌절감과 상실감으로 증명될 것입니다.
        </p>
    </section>

    <p className="heading-3 title2" data-aos="fade-down" data-aos-delay="600">
        결이 격을 만든다!
    </p>

    <section className="description" data-aos="zoom-in" data-aos-delay="900">
        <p>
            <mark>결이 좋다</mark> 라는 것은,<br />
            결이 좋다 라는 것은, 
            <mark> 목표가 뚜렷하다</mark>는 것이고 또한 <mark>속도감이좋다</mark>라는것을 의미합니다. <br/>
            <mark>속도감이란,</mark><br/>
            어떠한 상황에서든 깊이있는 준비력과 거침없는 이행력이라고 하는 흔들림 없는 
            목표설정 및 기준으로 만들어 집니다. 그래서, 준비된 아이들에게는 마음가
            짐은 물론 자세와 태도라는 것의 차이를 만들어 내는 것이고 이를 통해 격차를 
            보이는 것입니다.

            결국, <mark>결의 차이가 격을 좌우하는 것</mark>입니다.
        </p>
    </section>

</article>

<article className='art-img' data-aos="fade-left" data-aos-delay="1200">
    <MainPageSub03_1logo />
</article>  




{/* 
<article className='art-img' data-aos="fade-left" data-aos-delay="1200">

    <div className='txt-i'>I</div>
    
    <div className="circle-container">
      <div className="circle-text">
        {text.split("").map((char, i) => (
          <span
            key={i}
            style={{
              transform: `rotate(${i * (360 / text.length)}deg)`,
              color: colors[i % colors.length], // 순환하며 색상 변경
            }}
          >
            {char}
          </span>
        ))}
      </div>

    </div>
    
</article> */}




</section>


            </section>
        </div>
    );
};

export default MainPageSub03_1;
